module.exports = __webpack_public_path__ + "static/media/10.8e72df65.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/10.png
// module id = 1383
// module chunks = 0